export default {
  content: {
    languages: {
      en: "English",
    },
  },
}



// WEBPACK FOOTER //
// ./src/content/content.js